export default [
  {
    path: '/recruit-detail',
    name: 'recruit-detail',
    meta: { title: '职位详情', auth: true, deepth: 2 },
    component: () => import('../../views/recruit/recruit-detail.vue')
  },
  {
    path: '/recruit-share',
    name: 'recruit-share',
    meta: { title: '分享海报', auth: true, deepth: 2 },
    component: () => import('../../views/recruit/recruit-share.vue')
  }
];
